import { useState } from "react";
import PropTypes from "prop-types";
import { InputText } from "primereact/inputtext";
import { useIntl } from "react-intl";
import {
  getErrorMessage,
  bytesToNextBiggerUnit,
} from "../form/FormStandardProps";
import Label from "./Label";

const FileInput = ({
  className = "",
  input,
  label = "",
  meta,
  placeholder = "",
  required = false,
  disabled = false,
  readOnly = false,
  size = 1000 * 1024,
  onFileRead,
  ...rest
}) => {
  const intl = useIntl();
  const { touched, error } = meta || {};
  const [fileError, setFileError] = useState("");

  return (
    <div
      className={`edexlms-field file-input ${readOnly ? "readonly" : ""} ${
        disabled ? "disabled" : ""
      } `}
    >
      {(label && (
        <Label
          label={label}
          disabled={disabled}
          required={required}
          htmlFor={input.name}
        />
      )) ||
        null}
      <InputText
        {...input}
        {...rest}
        id={input.name}
        required={required}
        type={"file"}
        disabled={disabled || readOnly}
        invalid={touched && error}
        className={`edexlms-field-input w-full ${className}`}
        placeholder={placeholder}
        onChange={(e) => {
          const file = e.target?.files?.[0];
          if (file) {
            if (size && file?.size > size) {
              setFileError(
                intl.formatMessage(
                  { id: "file_size" },
                  { size: bytesToNextBiggerUnit(size) }
                )
              );
            } else {
              setFileError("");
              if (onFileRead) onFileRead(file);
              input.onChange(e);
            }
          }
        }}
      />
      {(touched && error && !fileError && (
        <div className="edexlms-field-error">
          {getErrorMessage(error, input, rest, label || placeholder)}
        </div>
      )) ||
        null}
      {(fileError && <div className="edexlms-field-error">{fileError}</div>) ||
        null}
    </div>
  );
};

FileInput.propTypes = {
  className: PropTypes.string,
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  size: PropTypes.number,
  onFileRead: PropTypes.func,
};

export default FileInput;
